export default {"src":"/_next/static/media/logo-white.5d33dfec.svg","height":145,"width":755,"blurWidth":0,"blurHeight":0};